import { render } from "./TopContainer.vue?vue&type=template&id=7dfd789f&scoped=true&bindings={\"width\":\"props\",\"height\":\"props\",\"align\":\"props\",\"pt\":\"props\",\"pb\":\"props\",\"pl\":\"props\",\"pr\":\"props\",\"padding\":\"props\",\"background\":\"props\"}"
import script from "./TopContainer.vue?vue&type=script&lang=js"
export * from "./TopContainer.vue?vue&type=script&lang=js"

import "./TopContainer.vue?vue&type=style&index=0&id=7dfd789f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dfd789f"

export default script